export enum EditAndConcatCustomEdlPosition {
  BeforeProgram = "BeforeProgram",
  AfterProgram = "AfterProgram",
}
